export default "__VITE_ASSET__21f1c9ef__"